var _path, _circle, _circle2, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExistingMember(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 78,
    viewBox: "0 0 86 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5624 66.6299L9.83594 76.465H74.1422",
    stroke: "#01AEB0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.0958,
    cy: 29.5597,
    r: 2.26963,
    fill: "#4D4D4D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.4171,
    cy: 29.5597,
    r: 2.26963,
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9574 38.7154C65.6236 39.9732 75.8435 43.2257 81.4105 51.1754C82.9957 53.4391 86.136 61.4449 77.0842 64.2055C71.4135 65.9349 64.9927 65.4142 55.5305 63.747C54.1777 63.4602 49.8664 62.1125 50.6012 57.9422C51.1222 54.9852 54.7384 53.6866 57.2424 54.031C61.4613 54.5324 69.527 55.1792 71.3489 53.9032",
    stroke: "#4D4D4D",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8213 44.0049L30.093 54.277",
    stroke: "#01AEB0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9785 62.5366L39.1642 67.048",
    stroke: "#01AEB0",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4954 45.7578C31.0912 44.7651 20.976 38.7343 19.8057 25.5383C18.9179 15.6409 27.0056 1.011 43.4268 1.51237C50.4265 1.82145 65.1308 7.46778 65.1614 25.2065C65.1703 30.3565 62.6509 38.0899 56.3444 42.246",
    stroke: "#4D4D4D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8102 6.10645C51.03 13.073 31.1999 11.958 21.9957 11.2208L19.6719 18.5467C39.2468 25.1815 57.2634 18.132 63.5514 12.603L57.8102 6.10645Z",
    fill: "#01AEB0",
    stroke: "#01AEB0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.46 33.5215C38.1062 35.3659 40.7407 38.4315 46.1089 35.938",
    stroke: "#4D4D4D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5061 39.7544C19.9386 41.3333 9.96938 45.288 4.96818 53.6053C3.54412 55.9736 0.967594 64.1784 10.1894 66.3033C15.9665 67.6345 22.3356 66.669 31.6591 64.3483C32.9887 63.9683 37.196 62.3243 36.1732 58.2151C35.448 55.3014 31.7503 54.2572 29.2762 54.7748C25.1024 55.5681 17.1011 56.7738 15.195 55.6275",
    stroke: "#4D4D4D",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExistingMember);
export default __webpack_public_path__ + "static/media/ExistingMember.a0df4c6ed2e5b85dd857a666cf1819bd.svg";
export { ForwardRef as ReactComponent };